module.exports = __webpack_public_path__ + "img/img5.d41b17c0.png";